// Carrinho do BALCÃO guardado na aba (30/09/2026: um F5 ou a tela recarregando
// no meio da venda perdia os itens bipados). Guarda carrinho, cliente, nome e
// desconto no sessionStorage (só naquela aba; some ao fechar) e restaura ao
// abrir o Balcão de novo. Apaga quando a venda termina (tela de confirmação) ou
// quando o carrinho esvazia (cancelar a compra, Entrega, venda nova). O Totem
// não guarda: lá quem compra é o cliente, e o recomeço limpa tudo.
import { useEffect, useRef } from "react";
import { toast } from "sonner";

const CHAVE = "nucleo:balcao_carrinho";

function ler() {
  try {
    const bruto = sessionStorage.getItem(CHAVE);
    return bruto ? JSON.parse(bruto) : null;
  } catch {
    return null;
  }
}

function gravar(valor) {
  try { sessionStorage.setItem(CHAVE, JSON.stringify(valor)); } catch { /* cheio ou bloqueado: segue sem guardar */ }
}

// Também para quem sai da tela na mesma hora (Entrega → Delivery): o efeito
// abaixo não chega a rodar depois que o Balcão desmonta.
export function apagarCarrinhoGuardado() {
  try { sessionStorage.removeItem(CHAVE); } catch { /* nada a fazer */ }
}
const apagar = apagarCarrinhoGuardado;

export function useCarrinhoGuardado({ ativo, screen, cart, setCart, cliente, setCliente, customerName, setCustomerName, desconto, setDesconto }) {
  const restaurou = useRef(false);
  // A tela do Balcão monta duas vezes ao abrir o painel: apagar o guardado
  // porque o carrinho "ainda" está vazio perdia a restauração. Só apaga o
  // carrinho vazio depois que esta montagem já teve itens (venda cancelada).
  const teveItens = useRef(false);

  // Uma vez, ao abrir: roda depois do "recomeçar" da montagem (useTotemFluxo),
  // então o que foi guardado vence a limpeza.
  useEffect(() => {
    if (!ativo || restaurou.current) return;
    restaurou.current = true;
    const salvo = ler();
    if (!Array.isArray(salvo?.cart) || !salvo.cart.length) return;
    setCart(salvo.cart);
    if (salvo.cliente) setCliente(salvo.cliente);
    if (salvo.customerName) setCustomerName(salvo.customerName);
    if (salvo.desconto?.tipo && salvo.desconto.tipo !== "none") setDesconto(salvo.desconto);
    toast.info("Carrinho recuperado: a venda continua de onde parou");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ativo]);

  useEffect(() => {
    // Virou Totem: a troca de modo recomeça do zero (useTotemFluxo) — o
    // guardado do Balcão não volta depois.
    if (!ativo) { apagar(); return; }
    if (!restaurou.current) return;
    if (screen === "confirmation") { apagar(); return; }
    if (!cart.length) { if (teveItens.current) apagar(); return; }
    teveItens.current = true;
    gravar({ cart, cliente, customerName, desconto, em: Date.now() });
  }, [ativo, screen, cart, cliente, customerName, desconto]);
}
